import * as _ from 'lodash';
import { Component, OnInit } from '@angular/core';
import { GridColumnComponent } from './base-grid-column-component';
/**
 * TODO: for STF-27616 - Switching between Regions - I've made this link button to use window.location.href to redirect user to the target URL instead of
 *   using the routerLink directive to navigate user to the url.  This is because we want to force a Refresh of the page such that the components get reloaded
 *   and will initialize with the correct Region.
 *   This approach might come back and bite us, but for now, this is the most effective approach to handle different region.  The potential issue is if we
 *   have some data that should get persisted in memory (like in the store, but store is "backed up" via hydration, so it should be fine).  Those data will
 *   be destroyed or reset when we refresh the page.  To fix, we should just stick them into the store or directly into session/local storage.
 * */
@Component({
  selector: 'st-link-button-column',
  template: `<button class="btn btn-link" (click)="onProjectSelected(url)">{{name}}</button>`
})
export class LinkButtonColumnComponent extends GridColumnComponent implements OnInit {
  name = '';
  url = [];
  constructor(private _window: Window) {
    super();
  }
  ngOnInit() {
    this.name = _.get(this.context, this.configPayload.name, '');
    this.url = _.get(this.context, this.configPayload.url, '');
  }
  onProjectSelected(url: string[]) {
    this._window.location.href = _.head(url) ?? '';
  }
}
